import { gql } from "@apollo/client";

export const FRAGMENT_PRODUCT = gql`
  fragment product on ProductType {
    id
    productType
    packingName
    odooId
    hsCode
    hsCodeForDestination
    name
    packingName
    number
    quantityPerCarton
    ctnNetWeight
    ctnGrossWeight
    outerCartonCbm
    outerCartonBarcodeEan
    innerBoxBarcodeEan
    innerBoxBarcodeUpc
    itemsPerSet
    outerCartonX
    outerCartonY
    outerCartonZ
    images: computedImages(size: "300x300") {
      id
      url
    }
    endFactories {
      id
      name
    }
  }
`;

export const FRAGMENT_SHIPMENT_INVOICE_ROW = gql`
  fragment shipmentInvoiceRow on ShipmentInvoiceRowType {
    id
    product {
      ...product
    }
    purchaseOrder {
      id
      number
    }
    packingName
    itemNumber
    productName
    hsCode
    hsCodeForDestination
    qtyPerCarton
    netWeight
    grossWeight
    cbm
    outerCartonX
    outerCartonY
    outerCartonZ
    customsName
    customsBrand
    customsUsage
    customsValue
    customsSize
    customsMaterials
    qty
    totalCarton
    totalNetWeight
    totalGrossWeight
    totalCbm
  }
  ${FRAGMENT_PRODUCT}
`;

export const FRAGMENT_SHIPMENT_INVOICE = gql`
  fragment shipmentInvoice on ShipmentInvoiceType {
    id
    pos {
      id
      number
    }
    invoice {
      id
      number
      odooModelId
      odooModelType
    }
    qcReports {
      id
      name
      qty
      status
      productNumber
      productName
    }
    shipmentInvoiceRows {
      ...shipmentInvoiceRow
    }
  }
  ${FRAGMENT_SHIPMENT_INVOICE_ROW}
`;

export const FRAGMENT_SHIPMENT_TOTALS = gql`
  fragment shipmentTotals on ShipmentType {
    id
    totalQty
    totalCarton
    totalNetWeight
    totalGrossWeight
    totalCbm
  }
`;

export const DELETE_SHIPMENT_INVOICE = gql`
  mutation DELETE_SHIPMENT_INVOICE($id: ID!) {
    deleteShipmentInvoice(id: $id) {
      id
      shipment {
        ...shipmentTotals
      }
    }
  }
  ${FRAGMENT_SHIPMENT_TOTALS}
`;

export const CREATE_SHIPMENT_INVOICE_ROW = gql`
  mutation CREATE_SHIPMENT_INVOICE_ROW(
    $shipmentInvoiceId: ID!
    $productId: ID
    $poId: ID
    $specialRowInput: ShipmentInvoiceRowUpdateInput
  ) {
    createShipmentInvoiceRow(
      shipmentInvoiceId: $shipmentInvoiceId
      productId: $productId
      poId: $poId
      specialRowInput: $specialRowInput
    ) {
      shipmentInvoiceRow {
        ...shipmentInvoiceRow
      }
      shipment {
        ...shipmentTotals
      }
    }
  }
  ${FRAGMENT_SHIPMENT_INVOICE_ROW}
  ${FRAGMENT_SHIPMENT_TOTALS}
`;

export const UPDATE_SHIPMENT_INVOICE_ROW_PRODUCT = gql`
  mutation UPDATE_SHIPMENT_INVOICE_ROW_PRODUCT(
    $shipmentInvoiceRowId: ID!
    $productId: ID!
  ) {
    updateShipmentInvoiceRowProduct(
      shipmentInvoiceRowId: $shipmentInvoiceRowId
      productId: $productId
    ) {
      shipmentInvoiceRow {
        ...shipmentInvoiceRow
        shipmentInvoice {
          id
        }
      }
      shipment {
        ...shipmentTotals
      }
    }
  }
  ${FRAGMENT_SHIPMENT_INVOICE_ROW}
  ${FRAGMENT_SHIPMENT_TOTALS}
`;

export const UPDATE_SHIPMENT_INVOICE_ROW = gql`
  mutation UPDATE_SHIPMENT_INVOICE_ROW(
    $shipmentInvoiceRowId: ID!
    $rowInput: ShipmentInvoiceRowUpdateInput
  ) {
    updateShipmentInvoiceRow(
      shipmentInvoiceRowId: $shipmentInvoiceRowId
      rowInput: $rowInput
    ) {
      shipmentInvoiceRow {
        ...shipmentInvoiceRow
        shipmentInvoice {
          id
        }
      }
      shipment {
        ...shipmentTotals
      }
    }
  }
  ${FRAGMENT_SHIPMENT_INVOICE_ROW}
  ${FRAGMENT_SHIPMENT_TOTALS}
`;
